import React, { useContext, useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import PropTypes from 'prop-types';
import { DesignContext } from '../../containers/GraphicBuilder/GraphicBuilder';
import './VFrameToolbar.css';
import _ from 'lodash';

const VFrameToolbar = props => {
  const { selectedEntity } = props;
  const dispatch = useDispatch();
  const { activePageRef } = useContext(DesignContext);
  const entity = useSelector(state => state.design.entitiesState[selectedEntity]);
  const colorPickerColor = useSelector(state => state.design.colorPickerColor);

  const [click, setClick] = useState({});
  const [bgColor, setBgColor] = useState();

  useEffect(() => {
    if (_.get(entity, 'data.medias.style.master.backgroundColor', 'transparent') !== bgColor)
      setBgColor(_.get(entity, 'data.medias.style.master.backgroundColor', 'transparent'));
  }, [bgColor, entity]);

  useEffect(() => {
    let colors = {};
    if (click.index > -1 && bgColor !== colorPickerColor) {
      colors.fill = click.type === 'fill' ? colorPickerColor : bgColor;
      const style = {
        medias: { frame: {}, style: { master: { backgroundColor: colorPickerColor } } },
      };
      dispatch(designActions.changeGridData(activePageRef.current, selectedEntity, style));
      setBgColor(colorPickerColor);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [colorPickerColor]);

  const onMouseDown = (index, color, type) => {
    dispatch(designActions.changeColorPickerColor(color));
    dispatch(designActions.setSidePanel('colorPicker'));
    setClick({
      index: index,
      type: type,
      selected: 'selected',
      fill: color,
      entity: selectedEntity,
    });
  };

  return (
    <div className="toolbar frameToolbar ">
      {bgColor && (
        <div className="colorPalette">
          <span
            className={
              `color ${1} ` + (click.index === 1 && click.type === 'fill' ? 'selected' : '')
            } //{`color ${selected}`}
            style={{ backgroundColor: `${bgColor}` }}
            onMouseDown={() => onMouseDown(1, bgColor, 'fill')}
          ></span>
        </div>
      )}
    </div>
  );
};

VFrameToolbar.propTypes = {
  selectedEntity: PropTypes.number,
};

export default VFrameToolbar;
